import { DisplayInput } from "@altertec_gparn/lib";
import { Expose } from "class-transformer";

export class StopTaskTypeDto {
  @Expose()
  stop: DisplayInput;
}
